// read notification actions
export const NOTIFICATION_READ_FETCH_START = 'NOTIFICATION_READ_FETCH_START';
export const NOTIFICATION_READ_FETCH_SUCCESS =
  'NOTIFICATION_READ_FETCH_SUCCESS';
export const NOTIFICATION_READ_FETCH_FAILURE =
  'NOTIFICATION_READ_FETCH_FAILURE';

export const NOTIFICATION_READ_REFRESH_START =
  'NOTIFICATION_READ_REFRESH_START';
export const NOTIFICATION_READ_REFRESH_SUCCESS =
  'NOTIFICATION_READ_REFRESH_SUCCESS';
export const NOTIFICATION_READ_REFRESH_FAILURE =
  'NOTIFICATION_READ_REFRESH_FAILURE';

export const NOTIFICATION_READ_LOAD_MORE_START =
  'NOTIFICATION_READ_LOAD_MORE_START';
export const NOTIFICATION_READ_LOAD_MORE_SUCCESS =
  'NOTIFICATION_READ_LOAD_MORE_SUCCESS';
export const NOTIFICATION_READ_LOAD_MORE_FAILURE =
  'NOTIFICATION_READ_LOAD_MORE_FAILURE';

// unread notification actions
export const NOTIFICATION_UNREAD_FETCH_START =
  'NOTIFICATION_UNREAD_FETCH_START';
export const NOTIFICATION_UNREAD_FETCH_SUCCESS =
  'NOTIFICATION_UNREAD_FETCH_SUCCESS';
export const NOTIFICATION_UNREAD_FETCH_FAILURE =
  'NOTIFICATION_UNREAD_FETCH_FAILURE';

export const NOTIFICATION_UNREAD_REFRESH_START =
  'NOTIFICATION_UNREAD_REFRESH_START';
export const NOTIFICATION_UNREAD_REFRESH_SUCCESS =
  'NOTIFICATION_UNREAD_REFRESH_SUCCESS';
export const NOTIFICATION_UNREAD_REFRESH_FAILURE =
  'NOTIFICATION_UNREAD_REFRESH_FAILURE';

export const NOTIFICATION_UNREAD_LOAD_MORE_START =
  'NOTIFICATION_UNREAD_LOAD_MORE_START';
export const NOTIFICATION_UNREAD_LOAD_MORE_SUCCESS =
  'NOTIFICATION_UNREAD_LOAD_MORE_SUCCESS';
export const NOTIFICATION_UNREAD_LOAD_MORE_FAILURE =
  'NOTIFICATION_UNREAD_LOAD_MORE_FAILURE';

export const UPDATE_UNREAD_NOTIFICATION_BADGE =
  'UPDATE_UNREAD_NOTIFICATION_BADGE';
export const SET_UNREAD_NOTIFICATION_BADGE = 'SET_UNREAD_NOTIFICATION_BADGE';

export const NOTIFICATION_RESET = 'NOTIFICATION_RESET';
